<template>
    <Xjevaluation/>
</template>
<script>
import Xjevaluation from 'place/evaluation/xjevaluation.vue'
export default {
    components:{
        Xjevaluation
    }
}
</script>
t